var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "container-listagem" },
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", icon: "el-icon-arrow-left" },
                  on: { click: _vm.voltar }
                },
                [_vm._v("Voltar para painéis")]
              ),
              _c("div", { staticClass: "container-titulo-painel" }, [
                _c("h2", [_vm._v(_vm._s(_vm.painel.nome))]),
                _c("span", [_vm._v(_vm._s(_vm.painel.descricao))])
              ]),
              _c(
                "Pesquisa",
                {
                  attrs: {
                    placeHolder: "Informe o nome da demanda",
                    cardStyle: {
                      margin: "0px 0px 10px 0px",
                      "border-radius": "12px"
                    },
                    hasPesquisaAvancada: true
                  },
                  on: {
                    search: _vm.handlePesquisa,
                    resetSearch: _vm.resetPesquisa,
                    searchAdvanced: _vm.pesquisarAvancado,
                    setCardTitle: _vm.setTituloPesquisa
                  }
                },
                [
                  _c(
                    "template",
                    { slot: "pesquisaAvancada" },
                    [
                      _c("pesquisa-avancada-demandas", {
                        attrs: {
                          painel: _vm.painel,
                          filtro: _vm.pesquisaAvancada
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "template",
                    { slot: "titulo" },
                    [
                      _c(
                        "el-row",
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("h2", { staticClass: "titulo" }, [
                              _vm._v(_vm._s(_vm.tituloPesquisa))
                            ])
                          ]),
                          _c(
                            "el-col",
                            {
                              staticClass: "container-titulo-pesquisa",
                              attrs: { span: 12 }
                            },
                            [
                              _c(
                                "el-popover",
                                {
                                  attrs: {
                                    placement: "left",
                                    title: "Gerenciar time",
                                    trigger: "click"
                                  }
                                },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticClass: "input select",
                                      attrs: {
                                        filterable: "filterable",
                                        multiple: "multiple",
                                        "collapse-tags": "collapse-tags",
                                        "filter-method": _vm.filtrarUsuarios,
                                        loading: _vm.loadingTime,
                                        placeholder: "Selecione",
                                        "value-key": "id"
                                      },
                                      on: {
                                        change: function($event) {
                                          return _vm.onTimeChange($event)
                                        }
                                      },
                                      model: {
                                        value: _vm.time,
                                        callback: function($$v) {
                                          _vm.time = $$v
                                        },
                                        expression: "time"
                                      }
                                    },
                                    _vm._l(_vm.usuariosFiltrados, function(
                                      usuario
                                    ) {
                                      return _c("el-option", {
                                        key: usuario.id,
                                        attrs: {
                                          disabled:
                                            usuario.id ===
                                            _vm.painel.criador.id,
                                          label: usuario.pessoa.nomeRazaoSocial,
                                          value: usuario
                                        }
                                      })
                                    }),
                                    1
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        slot: "reference",
                                        type: "success",
                                        icon: "el-icon-plus"
                                      },
                                      slot: "reference"
                                    },
                                    [_vm._v("Gerenciar time")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticClass: "default-card", attrs: { shadow: "hover" } },
        [
          _vm.modal
            ? _c("modal-cadastrar-demanda", {
                attrs: { idDemanda: _vm.idDemanda },
                on: {
                  closeModal: _vm.closeModal,
                  callbackSucesso: _vm.callbackModal
                }
              })
            : _vm._e(),
          _c("el-row", { staticClass: "container", attrs: { type: "flex" } }, [
            _c("h2", { staticClass: "titulo" }, [_vm._v("Demandas do painel")]),
            _c(
              "div",
              { staticClass: "button" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "success", icon: "el-icon-plus" },
                    on: { click: _vm.openModal }
                  },
                  [_c("span", { staticClass: "center" }, [_vm._v("Cadastrar")])]
                )
              ],
              1
            )
          ]),
          _c("app-divider-refresh-button", {
            attrs: {
              label: "Listagem de demandas",
              hasButton: true,
              content: "Atualizar cadastros"
            },
            on: { click: _vm.getDemandas }
          }),
          _c(
            "el-table",
            {
              staticClass: "table",
              attrs: { data: _vm.painel.demandas, size: "medium" },
              on: { "sort-change": _vm.sortChanged }
            },
            [
              _c("template", { slot: "empty" }, [_vm._v("Não há registros.")]),
              _c("el-table-column", {
                attrs: {
                  prop: "numeroDemanda",
                  label: "Nº",
                  width: "100",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "nome",
                  label: "Nome da demanda",
                  width: "auto",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "estadoDemanda.nome",
                  label: "Estado",
                  width: "auto",
                  formatter: _vm.Utils.formatEmptyRowNA,
                  sortable: "custom"
                }
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "",
                  label: "Progresso da atividade",
                  width: "auto"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.temAtividades
                          ? _c("el-progress", {
                              attrs: {
                                "text-inside": true,
                                "stroke-width": 20,
                                percentage:
                                  scope.row.porcentagemAtividadesCompletas,
                                status: "success"
                              }
                            })
                          : _c("span", [
                              _vm._v(_vm._s(_vm.Utils.formatEmptyRowNA()))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dataInicio",
                  label: "Data de início",
                  width: "auto"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.dataInicio
                          ? _c("span", [_vm._v(_vm._s(scope.row.dataInicio))])
                          : _c("span", [_vm._v("-")])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "dataEntrega",
                  label: "Data de entrega",
                  width: "auto"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: scope.row.dataEntregaJaPassou
                                ? "danger"
                                : scope.row.demandaAVencer
                                ? "warning"
                                : "success",
                              effect: "dark",
                              size: "medium"
                            }
                          },
                          [_vm._v(_vm._s(scope.row.dataEntrega))]
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "prioridade.nome",
                  label: "Prioridade",
                  width: "auto",
                  sortable: "custom"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.prioridade
                          ? _c(
                              "el-tag",
                              {
                                style: {
                                  "background-color":
                                    scope.row.prioridade.codigo,
                                  color: "white",
                                  border: "none"
                                },
                                attrs: { size: "medium" }
                              },
                              [_vm._v(_vm._s(scope.row.prioridade.nome))]
                            )
                          : _c("span", [
                              _vm._v(_vm._s(_vm.Utils.formatEmptyRowNA()))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "Responsável", width: "auto", minWidth: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.responsaveis &&
                        scope.row.responsaveis.length > 0
                          ? _c("avatar-list", {
                              attrs: {
                                data: scope.row.responsaveis,
                                label: "pessoa.nomeRazaoSocial"
                              }
                            })
                          : _c("span", [
                              _vm._v(_vm._s(_vm.Utils.formatEmptyRowNA()))
                            ])
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "Ações", width: "auto" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c("button-acoes", {
                          attrs: { acoes: _vm.botoesAcao(scope.row) }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            2
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-af30b72c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-af30b72c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/demandas/ListagemDemandas.vue
// module id = null
// module chunks = 